import axios from "axios";
import axiosInstance from "../axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const loginApi = async (payload: any) => {
  console.log("PAYY", payload);

  try {
    const response = await axios.post(
      BASE_URL + `v1/${STAGE}/dashboard/login`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log("errrrr", error);
  }
};
